<template>
    <div>
        <h1>{{ title }}</h1>
        <div>
            <a-button icon="plus">加入收藏</a-button>
        </div>
        <div class="rate">
            <a-rate :value="ProductionScore" :tooltips="desc" />
            <a-rate :value="DifficultyScore" :tooltips="desc" />
        </div>
    </div>
</template>

<script>

export default {
    props: [ 'info' ],
}
</script>

<style>

</style>